const _CHART_OBJECT = {
  home: {
    p: 0,
    v: '',
  },
  away: {
    p: 0,
    v: '',
  },
  visible: false,
};

const _COMPARISON_CHART_INIT = {
  expectedGoal: { ..._CHART_OBJECT, name: '예상 골(%)', key: 3 },
  bigChance: { ..._CHART_OBJECT, name: '득점 기회', key: 4 },
  attack: { ..._CHART_OBJECT, name: '공격 횟수', key: 5 },
  dangerousAttack: { ..._CHART_OBJECT, name: '위험 공격', key: 6 },
  shooting: { ..._CHART_OBJECT, name: '슈팅', key: 7 },
  shotsOnTarget: { ..._CHART_OBJECT, name: '유효슈팅', key: 8 },
  missedShot: { ..._CHART_OBJECT, name: '실축', key: 9 },
  blockedShot: { ..._CHART_OBJECT, name: '슈팅 막힘', key: 10 },
  foul: { ..._CHART_OBJECT, name: '파울', key: 11 },
  corner: { ..._CHART_OBJECT, name: '코너킥', key: 12 },
  freeKick: { ..._CHART_OBJECT, name: '프리킥', key: 13 },
  offside: { ..._CHART_OBJECT, name: '오프사이드', key: 14 },
  yellowCardCount: { ..._CHART_OBJECT, name: '옐로카드', key: 15 },
  redCardCount: { ..._CHART_OBJECT, name: '레드카드', key: 16 },
  possession: { ..._CHART_OBJECT, name: '점유율', key: 17 },
  passAttempted: { ..._CHART_OBJECT, name: '패스 횟수', key: 18 },
  passCompleted: { ..._CHART_OBJECT, name: '패스 성공', key: 19 },
  save: { ..._CHART_OBJECT, name: '세이브', key: 20 },
  interception1: { ..._CHART_OBJECT, name: '인터셉트', key: 21 },
  tackle: { ..._CHART_OBJECT, name: '태클', key: 22 },
  hitWoodwork: { ..._CHART_OBJECT, name: '골대 맞추기', key: 23 },
  shotInsideBox: { ..._CHART_OBJECT, name: '박스 안 슛', key: 24 },
  shotOutsideBox: { ..._CHART_OBJECT, name: '박스 밖 슛', key: 25 },
  touchOpponentBox: { ..._CHART_OBJECT, name: '상대 박스 안 터치', key: 26 },

  // interception2: { ..._CHART_OBJECT, name: '인터셉트2', key: 27 },
};

export { _COMPARISON_CHART_INIT };
